import React from 'react';
import {useSelectorWithRefresh} from '@/store/kysely_module';
import {useModule} from '@/hooks/useModule';
import {WavesurferWithHook} from '@/components/wavesurfer_with_hook';
import {DBObjects} from '@/store/store_types';

type WaveformData = {
    duration: number | undefined;
    waveform_data: number[][] | undefined;
} | null;

type Props = {
    fileInfo: DBObjects['File'];
    style?: React.CSSProperties;
    onTimestampAction?: (timestamp: string, action: 'comment') => void;
    waveformData?: WaveformData;
    isLoadingWaveform?: boolean;
};

export const FileWaveform = ({ fileInfo, style, onTimestampAction, waveformData: externalWaveformData, isLoadingWaveform: externalIsLoading }: Props) => {
    const audioPlayerModule = useModule('AudioPlayer');

    const shouldFetchInternal = !externalWaveformData && externalIsLoading === undefined;
    const [internalWaveformData, , internalIsLoading] = useSelectorWithRefresh(
        'getFileWaveformAndDuration',
        {file_id: shouldFetchInternal ? fileInfo.id : ''},
        null,
        {workspace_id: fileInfo.workspace_id, ignore: !shouldFetchInternal}
    );

    const waveformAndDuration = externalWaveformData ?? internalWaveformData;
    const isLoading = externalIsLoading ?? internalIsLoading;

    // Audio playback status
    const playbackStatus = audioPlayerModule.useAudioPlaybackStatus();
    const isCurrentFile = playbackStatus?.fileInfo?.id === fileInfo.id;
    const isPlaying = isCurrentFile && playbackStatus?.isPlaying;

    const defaultStyle: React.CSSProperties = {
        // border: '1px solid var(--mantine-color-gray-3)',
        boxShadow: '2px 2px 8px 1px black',
        borderRadius: '8px',
        padding: '10px',
        ...style
    };

    if (isLoading || !waveformAndDuration?.duration || !waveformAndDuration?.waveform_data) {
        return null;
    }

    return (
        <div style={defaultStyle}>
            <WavesurferWithHook
                height={60}
                isCurrentFile={isCurrentFile || false}
                isPlaying={isPlaying || false}
                onTimestampAction={onTimestampAction || (() => {})}
                duration={waveformAndDuration.duration}
                peaks={waveformAndDuration.waveform_data}
                regions={[]}
                onSeek={(seconds => {
                    audioPlayerModule.playAndSeek(fileInfo, seconds);
                })}
            />
        </div>
    );
};
